var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotTurquoise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#4dbfdb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotTurquoise);
export default __webpack_public_path__ + "static/media/DotTurquoise.e51a30fcbdbb94fed3ce590bdf773491.svg";
export { ForwardRef as ReactComponent };